export class GaiaConstants {
  static readonly SELECTED_TEAM_NAME = "Team";
  static readonly GUEST_TEAM = "guest";
  static readonly SELECTED_TEAM_DESCRIPTION = "TeamDescription";
  // Data related pages/components
  static readonly CUSTOMER_INFORMATION_LOOKUP = "CustomerInformationLookup";
  static readonly CUSTOMER_INFORMATION_LOOKUP_BY_BRAAVOS =
    "CustomerInformationLookupByBraavos";
  static readonly SELLER_INFORMATION_LOOKUP = "SellerInformationLookup";
  static readonly BRAZIL_MARKET_PLACE_SELLER_LOOKUP =
    "BrazilMarketPlaceSellerLookup";
  static readonly BULK_UPLOAD_WORKFLOW = "BulkUploadWorkflow";
  static readonly ATLAS_CHATBOT_CONVERSATIONS_LIMIT = 10;
  static readonly ATLAS_CHATBOT_MESSAGES_LIMIT = 10;
  static readonly NOTIFICATION_TIMEOUT = {
    SHORT: 5000,
    LONG: 10000,
  };
  static readonly PLACE_HOLDER = "placeholder";
  static readonly INDIA_DIRECT_TEAM = "india_direct";
  static readonly US_SALT_DIRECT_TEAM = "us_salt_direct";
  static readonly AUDIT_FILES_PREFIX = "audits";
  static readonly TEMPLATE_TEAMS = ["us_salt_direct", "us_salt_indirect"];
  static readonly TABLE_FILTER_OPERATORS = ["=", "!=", ":", "!:", "^", "!^"];
  static readonly DOCUMENT_API_BATCH_SIZE = 10;
  static readonly DOCUMENT_STORE_DISCLAIMER = "Gaia keeps files for 10 years.";
  static readonly DEFAULT_STATUS = "Not started";
}

export const TEAM_NAME_MAP: {
  [key: string]: string;
} = {
  apac_controversy: "APAC Controversy",
  brazil_indirect: "Brazil Indirect",
  canada: "Canada",
  germany_rc: "Germany R&C",
  emea_stores: "EMEA Stores",
  gaia_dev: "Gaia Dev",
  gts: "GTS",
  india_direct: "India Direct",
  itx_compliance: "ITX Compliance",
  us_fed_rc: "US Fed R&C",
  us_property_tax: "US Property Tax",
  us_salt_direct: "US SaLT Direct",
  us_salt_indirect: "US SaLT Indirect",
  us_salt_itc: "US SaLT ITC",
  us_state_rc: "US State R&C",
};

export type GAIAOBJECT_CATEGORY = "audit" | "notice" | "litigation" | "";
